import * as Action from '../action';

export default (state = {}, action) => {
  switch (action.type) {
    case Action.ADD_EXPORT_ORDER_HISTORY:
      return { ...action.exportOrderHistory };
    default:
      return state;
  }
};
